import { Navigate, type RouteObject } from "react-router-dom";

import { dashboardTabPath } from "./tabs";

/** Старые адреса разделов, слитых в дашборд. Вкладку склада не закрывают
 *  сутками, закладка обязана открыться, а не упасть в 404/на главную. */
export const warehouseDashboardLegacyRoutes: RouteObject[] = [
  // Оборачиваемость была отдельным разделом до 24.09.2026.
  {
    path: "warehouse-turnover",
    element: <Navigate to={dashboardTabPath("turnover")} replace />,
  },
];
